<template>
  <span
      itemscope
      itemtype="https://schema.org/Thing"
      itemprop="item">
      <meta itemprop="url" :content="contentUrl">
      <span
          itemscope
          itemtype="https://schema.org/Thing"
          itemprop="item"
          :id="validIdFromString(item.label)">
        <span itemprop="name">{{ item.label }}</span>
      </span>
      <meta itemprop="position" :content="index">
    </span>
</template>

<script>
import { removeWhitespaces } from '@paybis/frontend-common-lib/src/services/util';

export default {
  name: 'BreadcrumbItem',
  props: {
    index: { type: Number, required: true },
    item: { type: Object, required: true },
  },
  computed: {
    contentUrl () {
      return this.$route.path;
    },
  },
  methods: {
    validIdFromString(string) {
      return removeWhitespaces(string);
    },
  },
};
</script>
